import * as ambassadorWixPromoteSeoV1SeoPattern from './promote-seo-v1-seo-pattern-seo-patterns.http.js';
import * as ambassadorWixPromoteSeoV1SeoPatternTypes from './promote-seo-v1-seo-pattern-seo-patterns.types.js';
import * as ambassadorWixPromoteSeoV1SeoPatternUniversalTypes from './promote-seo-v1-seo-pattern-seo-patterns.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getSeoPattern(): __PublicMethodMetaInfo<
  'GET',
  { pageType: string },
  ambassadorWixPromoteSeoV1SeoPatternUniversalTypes.GetSeoPatternRequest,
  ambassadorWixPromoteSeoV1SeoPatternTypes.GetSeoPatternRequest,
  ambassadorWixPromoteSeoV1SeoPatternUniversalTypes.GetSeoPatternResponse,
  ambassadorWixPromoteSeoV1SeoPatternTypes.GetSeoPatternResponse
> {
  const payload = { pageType: ':pageType' } as any;

  const getRequestOptions =
    ambassadorWixPromoteSeoV1SeoPattern.getSeoPattern(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/seo-patterns/{pageType}',
    pathParams: { pageType: 'pageType' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listSeoPatterns(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPromoteSeoV1SeoPatternUniversalTypes.ListSeoPatternsRequest,
  ambassadorWixPromoteSeoV1SeoPatternTypes.ListSeoPatternsRequest,
  ambassadorWixPromoteSeoV1SeoPatternUniversalTypes.ListSeoPatternsResponse,
  ambassadorWixPromoteSeoV1SeoPatternTypes.ListSeoPatternsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromoteSeoV1SeoPattern.listSeoPatterns(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/seo-patterns',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listSeoPatternVariables(): __PublicMethodMetaInfo<
  'GET',
  { pageType: string },
  ambassadorWixPromoteSeoV1SeoPatternUniversalTypes.ListSeoPatternVariablesRequest,
  ambassadorWixPromoteSeoV1SeoPatternTypes.ListSeoPatternVariablesRequest,
  ambassadorWixPromoteSeoV1SeoPatternUniversalTypes.ListSeoPatternVariablesResponse,
  ambassadorWixPromoteSeoV1SeoPatternTypes.ListSeoPatternVariablesResponse
> {
  const payload = { pageType: ':pageType' } as any;

  const getRequestOptions =
    ambassadorWixPromoteSeoV1SeoPattern.listSeoPatternVariables(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/seo-patterns/{pageType}/variables',
    pathParams: { pageType: 'pageType' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createSeoPattern(): __PublicMethodMetaInfo<
  'POST',
  { pageType: string },
  ambassadorWixPromoteSeoV1SeoPatternUniversalTypes.CreateSeoPatternRequest,
  ambassadorWixPromoteSeoV1SeoPatternTypes.CreateSeoPatternRequest,
  ambassadorWixPromoteSeoV1SeoPatternUniversalTypes.CreateSeoPatternResponse,
  ambassadorWixPromoteSeoV1SeoPatternTypes.CreateSeoPatternResponse
> {
  const payload = { pageType: ':pageType' } as any;

  const getRequestOptions =
    ambassadorWixPromoteSeoV1SeoPattern.createSeoPattern(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/seo-patterns/{pageType}',
    pathParams: { pageType: 'pageType' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setSeoPattern(): __PublicMethodMetaInfo<
  'PATCH',
  { pageType: string },
  ambassadorWixPromoteSeoV1SeoPatternUniversalTypes.SetSeoPatternRequest,
  ambassadorWixPromoteSeoV1SeoPatternTypes.SetSeoPatternRequest,
  ambassadorWixPromoteSeoV1SeoPatternUniversalTypes.SetSeoPatternResponse,
  ambassadorWixPromoteSeoV1SeoPatternTypes.SetSeoPatternResponse
> {
  const payload = { pageType: ':pageType' } as any;

  const getRequestOptions =
    ambassadorWixPromoteSeoV1SeoPattern.setSeoPattern(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/seo-patterns/{pageType}',
    pathParams: { pageType: 'pageType' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function resetSeoPatternToDefault(): __PublicMethodMetaInfo<
  'POST',
  { pageType: string },
  ambassadorWixPromoteSeoV1SeoPatternUniversalTypes.ResetSeoPatternToDefaultRequest,
  ambassadorWixPromoteSeoV1SeoPatternTypes.ResetSeoPatternToDefaultRequest,
  ambassadorWixPromoteSeoV1SeoPatternUniversalTypes.ResetSeoPatternToDefaultResponse,
  ambassadorWixPromoteSeoV1SeoPatternTypes.ResetSeoPatternToDefaultResponse
> {
  const payload = { pageType: ':pageType' } as any;

  const getRequestOptions =
    ambassadorWixPromoteSeoV1SeoPattern.resetSeoPatternToDefault(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/seo-patterns/{pageType}/reset-to-default',
    pathParams: { pageType: 'pageType' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SeoPattern as SeoPatternOriginal,
  SeoPatternBlob as SeoPatternBlobOriginal,
  Tag as TagOriginal,
  PatternSource as PatternSourceOriginal,
  PatternSourceWithLiterals as PatternSourceWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  GetSeoPatternRequest as GetSeoPatternRequestOriginal,
  GetSeoPatternResponse as GetSeoPatternResponseOriginal,
  ListSeoPatternsRequest as ListSeoPatternsRequestOriginal,
  ListSeoPatternsResponse as ListSeoPatternsResponseOriginal,
  ListSeoPatternVariablesRequest as ListSeoPatternVariablesRequestOriginal,
  ListSeoPatternVariablesResponse as ListSeoPatternVariablesResponseOriginal,
  SeoPatternVariable as SeoPatternVariableOriginal,
  CreateSeoPatternRequest as CreateSeoPatternRequestOriginal,
  CreateSeoPatternResponse as CreateSeoPatternResponseOriginal,
  SetSeoPatternRequest as SetSeoPatternRequestOriginal,
  SetSeoPatternResponse as SetSeoPatternResponseOriginal,
  ResetSeoPatternToDefaultRequest as ResetSeoPatternToDefaultRequestOriginal,
  ResetSeoPatternToDefaultResponse as ResetSeoPatternToDefaultResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GetSeoPatternApplicationErrors as GetSeoPatternApplicationErrorsOriginal,
  ListSeoPatternVariablesApplicationErrors as ListSeoPatternVariablesApplicationErrorsOriginal,
  CreateSeoPatternApplicationErrors as CreateSeoPatternApplicationErrorsOriginal,
  SetSeoPatternApplicationErrors as SetSeoPatternApplicationErrorsOriginal,
  ResetSeoPatternToDefaultApplicationErrors as ResetSeoPatternToDefaultApplicationErrorsOriginal,
} from './promote-seo-v1-seo-pattern-seo-patterns.types.js';
